const STANDSTILL_REASONS = {
  STANDSTILL: '',
  STANDSTILL_TRUCKS_QUEUE: 'Queue',
  STANDSTILL_GOODS_NOT_AVAILABLE: 'goods not available',
  STANDSTILL_BAD_REFERENCE: 'Bad reference',
  STANDSTILL_CLOSED_WAREHOUSE: 'Closed warehouse',
  STANDSTILL_MISSING_PLATES: 'Missing license plates',
  STANDSTILL_SLOW_LOADING: 'Slow un/loading',
  STANDSTILL_OTHER: 'Other reason',
  REASON_OTHER: 'Other reason',
};

export const UNLOCK_FOR_AGENTS_REASONS = {
  COMPLEX_DUE_TO_SPECIFICATIONS_ORDER: 'Order is too complex (height, weight, etc)',
  CONTRACT_OR_RECURRENT_ORDER: 'Order is part of a contract/recurrent',
  FOR_SERVICE_FLEET_ORDER: 'I need this order to feed my fleet',
  NON_ROUTABLE_ORDER: 'Order is not routable',
  COMPLICATED_LOCATION_ORDER: 'Complicated pickup or droppoff locations',
  CUSTOMER_PRIVILEGE_ORDER: 'I need to take care of this customer',
  // IS_CODI: 'Is CoDi',
  MOVED_BY_RESCUER: 'Moved automatically by Rescuer',
  IS_URGENT: 'Time for pickupis near',
  // IS_XDOCK: 'Is X-Dock order',
  REASON_OTHER: 'Other reason',
};

export const UNLOCK_JOURNEY_FOR_AGENTS_REASONS = {
  SPECIFIC_DRIVER_ASSIGNMENT: 'I need to assign a specific driver',
  CREATE_OWN_ROUTE: 'I need this order to make my own route',
  BAD_ROUTE: 'This route is not good',
  NON_ROUTABLE_ORDER: 'Order is not routable',
  MOVED_BY_RESCUER: 'Moved automatically by Rescuer',
  BASE_COST_IS_WRONG: 'Base cost is wrong',
  ADD_EXTRA_COST: 'I need to add an extra cost',
  // IS_CODI: 'Is CoDi',
  REASON_OTHER: 'Other reason',
};

export const REJECTION_ITINERARY_FEEDBACK_REASONS = {
  MARGIN_TOO_LOW: 'Margin is too low',
  DISTANCE_TOO_LONG: 'Distance is too long',
  SCHEDULED_TIME_TOO_TIGHT: 'Time schedule is too tight',
  RUNNING_EMPTY_KM_FOR_TOO_LONG: 'Running empty for too long',
  ROUTE_HAS_NO_RETURN: 'Route has no return',
  ROUTE_STARTS_OR_STOPS_IN_REMOTE_AREA: 'Route starts/stops in remote area',
  OTHER_REASON: 'Other reason',
};

export const JOURNEY_LAUNCHED_TO_POOL_REASONS = {
  CLOSE_TO_START: 'Close to pick-up time window',
  LOW_ROUTING_PROBABILITY: 'Low routing probability',
  TIME_TO_LAUNCH_AUTOMATIC_BY_VEHICLE_TYPE: 'Scheduled launch due to vehicle type', //not used anymore
  TIME_TO_LAUNCH_TYCOON: 'Scheduled launch',
  TIME_TO_LAUNCH_TYCOON_MARGIN: 'Scheduled launch due to margin',
  BIDDING_ENABLED: 'Launched to enable bidding',
  DAILY_RELAUNCH: 'Daily relaunch',
  TIME_TO_LAUNCH_SAFE_NET: 'Safe net scheduled launch (after working hours)',
  SHIPPER_CANCELS_EARLY: 'Shipper is unlikely to cancel',
  REASON_OTHER: 'Other reason', //not used anymore
};

export const SCAN_SKIPPED_REASONS = {
  DECIDED_BY_DRIVER: 'Decided by driver',
};

const logTexts = {
  action_names: {
    ASSIGN_DRIVER: 'Driver assigned manually',
    DELETE_CARGO_MANIFEST: 'PoD deleted',
    CHANGE_JOURNEY_STATUS: 'Status changed',
    CANCEL_SHIPPER_ORDER: 'Order cancelled',
    UNASSIGN_DRIVER: 'Driver manually unassigned',
    UPDATE_SHIPPER_ORDER: 'Order edited',
    EDIT_SHIPPER_ORDER_BY_SHIPPER: 'Order edited by shipper',
    CREATE_SHIPPER_ORDER: 'Order created',
    UPDATE_PRICE: 'Price has changed',
    UPDATE_PRICE_BY_STANDSTILL: 'Standstill charged to shipper',
    UPDATE_PRICE_BY_INCIDENT: 'Price changed because of an incident',
    UPLOAD_CARGO_MANIFEST: 'PoD uploaded',
    ACTION_MANUAL_BILLING: 'Manual Billing checked',
    UPDATE_PENALTY: 'Cost penalty',
    UPDATE_COST_INCREMENT: 'Cost increased',
    UPDATE_BONUS: 'Bonus added',
    ZENDESK_STANDSTILL_PICKUP: 'Standstill in pickup',
    ZENDESK_STANDSTILL_DROPOFF: 'Standstill in dropoff',
    ACTION_OTHER: 'Manual entry',
    STANDSTILL_PICKUP_WARNING_TO_SHIPPER: 'Driver warns of standstill in pick-up',
    STANDSTILL_DROPOFF_WARNING_TO_SHIPPER: 'Driver warns of standstill in drop-off',
    UNASSIGNED_BY_DRIVER: 'Driver dropped the job',
    ACCEPTED_OFFER_BY_DRIVER: 'Driver accepted the job',
    JOURNEY_LAUNCHED_TO_POOL: 'Launched to the pool',
    JOURNEY_CREATED_FROM_ITINERARY: 'Journey created',
    AUTOMATIC_COST_INCREMENT_APPLIED: 'Cost incremented automatically',
    AUTOMATIC_PENALTY_APPLIED: 'Penalty applied automatically',
    UNLOCK_FOR_AGENTS: 'Set order to manual',
    UNLOCK_JOURNEY_FOR_AGENTS: 'Set job to manual',
    TASK_CREATED_MANUALLY: 'Task created manually',
    TASK_CREATED_AUTOMATICALLY: 'Task created automatically',
    TASK_CREATED_DRIVER: 'Task created by Driver',
    TASK_CREATED_XDOCK: 'Task created by xDock',
    TASK_SOLVED_MANUALLY: 'Task solved manually',
    TASK_SOLVED_AUTOMATICALLY: 'Task solved automatically',
    TASK_ASSIGNED_TO_NEW_OWNER: 'Task assigned to new owner',
    TASK_UNASSIGNED_OWNER_UNAVAILABLE: 'Job moved to No owner due to unavailable agent',
    TASK_REVIEWED: 'Task reviewed',
    TASK_UPDATED: 'Task updated',
    TASK_SCHEDULED_MANUALLY: 'Task scheduled manually',
    TASK_SCHEDULED_AUTOMATICALLY: 'Task scheduled automatically',
    TASK_TO_PENDING_REVIEW: 'Task moved back to be reviewed',
    CARRIER_CALLED_THE_WAREHOUSE: 'Carrier called the warehouse',
    EMAIL_OFFER_SENT: 'Offer sent by email',
    DRIVER_ASSIGNED_AUTOMATICALLY: 'Driver assigned automatically',
    BID_OFFER_BY_DRIVER: 'Driver bid the job',
    SO_RETURN_CREATED: 'Return order created',
    JOURNEY_FROZEN_MANUALLY: 'Journey frozen manually',
    JOURNEY_FROZEN_AUTOMATICALLY: 'Journey frozen automatically',
    UNABLE_TO_FREEZE_AUTOMATICALLY: 'Unable to freeze automaticaly',
    CHAT_TASK_SOLVED: 'Task solved automatically',
    CHAT_TASK_CREATED: 'Task created automatically',
    SHIPPER_ORDER_BROKEN: 'Order removed from job',
    JOURNEY_BROKEN: 'Job broken',
    XDOCK_AUXILIARY_ORDERS_CREATED: 'Create x-Dock orders',
    SEND_DOCUMENTATION_TO_DRIVER: 'Documentation sent to driver',
    TRACKING_START: 'Journey tracked with Project44',
    ORDER_PDF_DOWNLOADED: 'Carrier downloaded the Order PDF',
    CSA_JOURNEY_OWNERSHIP: 'Journey ownership set automatically',
    DRIVER_NOT_ASSIGNED_YET: 'Email warning sent to Shipper: "No driver assigned yet"',
    EMAIL_TO_SHIPPER_SENT: '"Possible delay" email sent',
    POSSIBLE_EMAIL_TO_SHIPPER: '"Possible delay" email planned',
    SCAN_SKIPPED: 'Scan skipped',
    LOAD_SCANNED: 'Load scanned',
    LOAD_SCANNED_MISSING: 'Missing pallets while scanning',
    APPOINTMENT_BOOKED: 'Appointment Booked',
    ACCEPTED_OFFER_IMPROVEMENT_BY_DRIVER: 'Driver accepted the job improvement',
    REJECTED_OFFER_IMPROVEMENT_BY_DRIVER: 'Driver rejected the job improvement',
    JOURNEY_STOP_TIME_UPDATED: 'Time window at crossdock edited',
    CHAT_SENT_AUTOMATICALLY: 'Chat sent automatically',
    CHANGE_CROSS_DOCK_DECISIONS: 'Cross-docks changed',
    JOURNEY_UPGRADED: 'Journey upgraded',
    PORTIC_BCN_PICKUP_NOTICE_ERROR: 'Error in pickup/delivery notice of goods',
    PORTIC_BCN_DROPOFF_NOTICE_ERROR: 'Error in pickup/delivery notice of goods',
    PORTIC_BCN_PICKUP_NOTICE_SUCCESS: 'Successful pickup notice of goods',
    PORTIC_BCN_DROPOFF_NOTICE_SUCCESS: 'Successful delivery Notice of goods',
    PORTIC_BCN_PICKUP_NOTICE_UNANSWERED: 'Pickup notice of goods delivered without response',
    PORTIC_BCN_DROPOFF_NOTICE_UNANSWERED: 'Delivery notice of goods delivered without response',
  },
  titles: {
    ASSIGN_DRIVER: 'Why did you assign the driver?',
    DELETE_CARGO_MANIFEST: 'Why did you delete this POD?',
    CHANGE_JOURNEY_STATUS: 'Why did you update the status?',
    CANCEL_SHIPPER_ORDER: 'Why did you cancel this order?',
    UNASSIGN_DRIVER: 'Why did you unassign the driver?',
    UPDATE_SHIPPER_ORDER: 'Why did you edit this order?',
    EDIT_SHIPPER_ORDER_BY_SHIPPER: 'Why did you edit this order?',
    CREATE_SHIPPER_ORDER: 'Why did you create this order?',
    UPDATE_PRICE: 'Why did you change the price?',
    UPDATE_PRICE_BY_INCIDENT: 'You added an extra because of an incident',
    UPLOAD_CARGO_MANIFEST: 'Why did you upload this POD?',
    ACTION_MANUAL_BILLING: 'Why did you check manual invoicing?',
    UPDATE_COST_INCREMENT: 'Why did you change the cost?',
    UPDATE_PENALTY: 'Why did you change the cost?',
    ACTION_OTHER: 'Manual log entry',
  },
  reasons: {
    ASSIGN_DRIVER: {
      SPECIFIC_DRIVER: 'We want it to be done by a particular driver',
      NOT_ACCEPTED_AUTOMATICALLY: 'Not automatically accepted',
      REASON_OTHER: 'Another reason',
    },
    DELETE_CARGO_MANIFEST: {
      WRONG_PICTURE: 'The document is not a valid PoD',
      BAD_PICTURE: 'The text is not clearly visible',
      BAD_FORMAT: 'The document is not the format requested by the Shipper',
      WRONG_STOP: 'The document is under the wrong stop',
      MISSING_PAGES: 'The document is missing pages',
      INCOMPLETE: 'The document is missing stamp or signature',
      MISSING_BL: 'Missing additional documents (BL)',
      REASON_OTHER: 'Another reason',
    },
    CHANGE_JOURNEY_STATUS: {
      DRIVER_CANNOT_DO: "Driver can't do it",
      DRIVER_FORGET: 'Driver has forgotten to do it',
      REASON_OTHER: 'Another reason',
    },
    CANCEL_SHIPPER_ORDER: {
      REQUESTED_BY_SHIPPER: 'Requested by shipper (except duplicate)',
      LOAD_NOT_READY: 'Load is not ready',
      DRIVER_LATE_FOR_PICKUP: 'Driver is late for pickup',
      DRIVER_NOT_FOUND: 'No driver found',
      DUPLICATED_ORDER: 'Duplicated order',
      LOAD_IS_NOT_WHAT_SHIPPER_SAID: 'Load is not what the shipper told us',
      EXCEPTION_IN_RECURRING_ORDER: 'Exception in a recurring order',
      REASON_OTHER: 'Another reason',
      SO_TOO_LONG_ASSIGNATION: 'Too long to assign',
      SO_I_DONT_NEED_IT_OR_CANT_DO_IT: 'No longer need it',
    },
    UNASSIGN_DRIVER: {
      DRIVER_CANNOT_DO: "Driver can't do the job",
      VEHICLE_NOT_VALID: 'Vehicle is not right for the job',
      ROUTE_WRONG_PLANNIFIED: 'Badly planned / complex route',
      CARRIER_IS_UNWILLING: "Driver doesn't want to do the job",
      CARRIER_IS_UNABLE: 'Driver can’t do the job',
      SYSTEM_MISMATCH: "Ontruck's decision",
      REASON_OTHER: 'Another reason',
    },
    UPDATE_SHIPPER_ORDER: {
      SHIPPER_ORDER_CHANGED: 'The order has changed',
      SHIPPER_ORDER_WRONG: 'Information was missing or was wrong',
      REASON_OTHER: 'Another reason',
    },
    CREATE_SHIPPER_ORDER: {
      SHIPPER_LAZY: 'The shipper is awesome',
      SHIPPER_FIRST_TIME: "It's the shipper's first time",
      AREA_UNAVAILABLE: 'We do not allow shipments with this postal code / area',
      REASON_OTHER: 'Another reason',
    },
    UPDATE_PRICE: {
      NOT_ACCEPTED_AUTOMATICALLY: 'No drivers accept the order',
      GROUPAGE: 'Groupage (to create profit)',
      REASON_OTHER: 'Another reason',
    },
    UPDATE_PRICE_BY_STANDSTILL: {
      REASON_OTHER: 'Another reason',
    },
    UPDATE_PRICE_BY_INCIDENT: {
      REASON_OTHER: 'Another reason',
    },
    UPLOAD_CARGO_MANIFEST: {
      APP_FAILED: 'App crash',
      DRIVER_LAZY: 'Driver is a bum',
      REASON_OTHER: 'Another reason',
    },
    ACTION_MANUAL_BILLING: {
      REASON_OTHER: 'Another reason',
    },
    UPDATE_COST_INCREMENT: {
      SHIPPER_ORDER_OF_RECURRING_ORDER_EDITED:
        'A shipper order of a recurring order has been edited',
      AGREEMENT_SHIPPER: 'We have an agreement with the shipper',
      AGREEMENT_CARRIER: 'We have an agreement with the carrier',
      CORNER_CASE: 'It is a corner case',
      CARRIER_NEGOCIATED_COST: 'The carrier has negotiated the cost',
      JOURNEY_NOT_ASSIGNED_BY_ITSELF: 'The order does not get assigned by itself',
      REASON_OTHER: 'Another reason',
    },
    ACTION_OTHER: {
      SUPPORT: 'We have given support',
      DOCUMENTATION: 'Documentation',
      REASON_OTHER: 'Another reason',
    },
    DRIVER_NOT_ASSIGNED_YET: {
      DRIVER_NOT_FOUND: 'Driver not found',
      REASON_OTHER: 'Another reason',
    },
    AUTOCANCEL_SHIPPER_ORDER: {
      DRIVER_NOT_FOUND: 'Driver not found',
      REASON_OTHER: 'Another reason',
    },
    STANDSTILL_PICKUP_WARNING_TO_SHIPPER: {
      ...STANDSTILL_REASONS,
    },
    STANDSTILL_DROPOFF_WARNING_TO_SHIPPER: {
      ...STANDSTILL_REASONS,
    },
    TASK_CREATED_AUTOMATICALLY: {
      REASON_OTHER: '',
      DELAY_RISK: 'Order at risk of delay',
    },
    ZENDESK_STANDSTILL_PICKUP: {
      ...STANDSTILL_REASONS,
    },
    ZENDESK_STANDSTILL_DROPOFF: {
      ...STANDSTILL_REASONS,
    },
    UNLOCK_FOR_AGENTS: {
      ...UNLOCK_FOR_AGENTS_REASONS,
      ...UNLOCK_JOURNEY_FOR_AGENTS_REASONS,
    },
    UNLOCK_JOURNEY_FOR_AGENTS: {
      ...UNLOCK_FOR_AGENTS_REASONS,
      ...UNLOCK_JOURNEY_FOR_AGENTS_REASONS,
    },
    CARRIER_CALLED_THE_WAREHOUSE: {
      CLOSED_WAREHOUSE: 'Warehouse looks closed',
      CANT_FIND_WAREHOUSE: "Can't find the warehouse",
    },
    AUTOMATIC_COST_INCREMENT_APPLIED: {
      COST_ADJUSTMENT: 'Cost adjusted to fixed amount',
      COST_ADJUSTMENT_FOR_SELECTED_BID: 'Cost adjusted to bid assignation',
      COST_ADJUSTMENT_FOR_OFFERED_JOURNEY: 'Cost adjusted back to original journey amount',
    },
    AUTOMATIC_PENALTY_APPLIED: {
      COST_ADJUSTMENT: 'Cost adjusted to fixed amount',
      COST_ADJUSTMENT_FOR_SELECTED_BID: 'Cost adjusted to accepted bid',
      COST_ADJUSTMENT_FOR_OFFERED_JOURNEY: 'Cost adjusted back to original amount',
    },
    TASK_SCHEDULED_MANUALLY: {
      WITH_TIMER: 'With timer',
    },
    TASK_SCHEDULED_AUTOMATICALLY: {
      WITH_TIMER: 'With timer',
    },
    CHAT_TASK_SOLVED: {
      CHAT: 'Chat',
    },
    CHAT_TASK_CREATED: {
      CHAT: 'Chat',
    },
    JOURNEY_BROKEN: {
      SHIPPER_ORDER_BROKEN_NO_REASON: 'Order removed',
    },
    SHIPPER_ORDER_BROKEN: {
      SHIPPER_ORDER_BROKEN_BY_LAUNCH: 'Launch',
      SHIPPER_ORDER_BROKEN_BY_RELEASE: 'Release',
      SHIPPER_ORDER_BROKEN_BY_ASSIGN: 'Assign',
    },
    SEND_DOCUMENTATION_TO_DRIVER: {
      DOCUMENTATION: '',
    },
    JOURNEY_LAUNCHED_TO_POOL: {
      ...JOURNEY_LAUNCHED_TO_POOL_REASONS,
    },
    SCAN_SKIPPED: {
      ...SCAN_SKIPPED_REASONS,
    },
  },
};

export default logTexts;
